"use strict";
// Copyright Epic Games, Inc. All Rights Reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.MouseEventButtonsMask = exports.MouseEventButton = void 0;
/**
 * Mouse Button Data
 * {@link https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button}
 */
class MouseEventButton {
}
exports.MouseEventButton = MouseEventButton;
MouseEventButton.mainButton = 0; // Left button.
MouseEventButton.auxiliaryButton = 1; // Wheel button.
MouseEventButton.secondaryButton = 2; // Right button.
MouseEventButton.fourthButton = 3; // Browser Back button.
MouseEventButton.fifthButton = 4; // Browser Forward button.
/**
 * Mouse Button Mask Data
 * {@link https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons}
 */
class MouseEventButtonsMask {
}
exports.MouseEventButtonsMask = MouseEventButtonsMask;
MouseEventButtonsMask.primaryButton = 1; // Left button.
MouseEventButtonsMask.secondaryButton = 2; // Right button.
MouseEventButtonsMask.auxiliaryButton = 4; // Wheel button.
MouseEventButtonsMask.fourthButton = 8; // Browser Back button.
MouseEventButtonsMask.fifthButton = 16; // Browser Forward button.
